import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractFirstParagraph',
  standalone: true
})
export class ExtractFirstParagraphPipe implements PipeTransform {
  transform(htmlString: string): string {
    if (!htmlString) {
      return '';
    }
    const match = htmlString.match(/<p>(.*?)<\/p>/);
    if (!match) {
      return '';
    }
    return match[1].replace(/<\/?span[^>]*>/g, '');
  }
}
